<template>
  <div>
    <div v-if="isMyCard === 0">
      <template v-if="isShowLoading">
        <loading></loading>
      </template>
      <div :class="$style.cardTitle">
        我的银行卡
        <span>已添加<em>{{count}}</em>张银行卡</span>
      </div>
      <dl>
        <dd v-for="(item,idx) in cardLists" :key="idx" :class="$style.item" @click.stop="$emit('changeNo',2, item)">
          <img :src="item.src" :class="$style.img" />
          <h4>{{ item.bank && item.bank.bankName }}</h4>
          <p><span style="vertical-align: -3px;margin-right: 3px;vertical-align: -3px;font-size: 14px;">***************</span>{{item.accountNo}}</p>
        </dd>
        <dt :class="$style.item" @click.stop="$emit('changeNo', 1)">
          <Icon type="md-add" :class="$style.icon" />
          <p :class="$style.desc">添加银行卡</p>
        </dt>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "my-bank-card",
  data () {
    return {
      isMyCard: 0,
      isShowLoading: false,
      count: 0,
      cardLists: [],
      imgs: [
        {
          code: 'ABC',
          url: require('./imgs/ABC.png'),
        },
        {
          code: 'BEA',
          url: require('./imgs/BEA.png'),
        },
        {
          code: 'BOB',
          url: require('./imgs/BOB.png'),
        },
        {
          code: 'BOC',
          url: require('./imgs/BOC.png'),
        },
        {
          code: 'BOCM',
          url: require('./imgs/BOCM.png')
        },
        {
          code: 'BOHC',
          url: require('./imgs/BOHC.png'),
        },
        {
          code: 'BOS',
          url: require('./imgs/BOS.png'),
        },
        {
          code: 'CCB',
          url: require('./imgs/CCB.png'),
        },
        {
          code: 'CDCB',
          url: require('./imgs/CDCB.png'),
        },
        {
          code: 'CDRCB',
          url: require('./imgs/CDRCB.png'),
        },
        {
          code: 'CEB',
          url: require('./imgs/CEB.png'),
        },
        {
          code: 'CGB',
          url: require('./imgs/CGB.png'),
        },
        {
          code: 'CIB',
          url: require('./imgs/CIB.png'),
        },
        {
          code: 'CITIB',
          url: require('./imgs/CITIB.png'),
        },
        {
          code: 'CITIC',
          url: require('./imgs/CITIC.png'),
        },
        {
          code: 'CMB',
          url: require('./imgs/CMB.png'),
        },
        {
          code: 'CMBC',
          url: require('./imgs/CMBC.png'),
        },
        {
          code: 'CZSB',
          url: require('./imgs/CZSB.png'),
        },
        {
          code: 'EBCL',
          url: require('./imgs/EBCL.png'),
        },
        {
          code: 'HXB',
          url: require('./imgs/HXB.png'),
        },
        {
          code: 'ICBC',
          url: require('./imgs/ICBC.png'),
        },
        {
          code: 'LSCCB',
          url: require('./imgs/LSCCB.png'),
        },
        {
          code: 'LSZSH',
          url: require('./imgs/LSZSH.png'),
        },
        {
          code: 'NCCC',
          url: require('./imgs/NCCC.png'),
        },
        {
          code: 'PAB',
          url: require('./imgs/PAB.png'),
        },
        {
          code: 'PSBC',
          url: require('./imgs/PSBC.png'),
        },
        {
          code: 'PZHCCB',
          url: require('./imgs/PZHCCB.png'),
        },
        {
          code: 'SCB',
          url: require('./imgs/SCB.png'),
        },
        {
          code: 'SCRCU',
          url: require('./imgs/SCRCU.png'),
        },
        {
          code: 'SDB',
          url: require('./imgs/SDB.png'),
        },
        {
          code: 'SG',
          url: require('./imgs/SG.png'),
        },
        {
          code: 'SHBC',
          url: require('./imgs/SHBC.png'),
        },
        {
          code: 'SNCCB',
          url: require('./imgs/SNCCB.png'),
        },
        {
          code: 'SPDB',
          url: require('./imgs/SPDB.png'),
        },
        {
          code: 'SZRB',
          url: require('./imgs/SZRB.png'),
        },
        {
          code: 'UOB',
          url: require('./imgs/UOB.png'),
        },
        {
          code: 'YACCB',
          url: require('./imgs/YACCB.png'),
        },
        {
          code: 'ZGCB',
          url: require('./imgs/ZGCB.png'),
        }
      ]
    };
  },
  async mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.isShowLoading = true;
      this.userId = sessionStorage.getItem('userName');

      try {
        let res = await this.$http.get(
          `${this.lee}/ec/bindBank/v1/getBankList?access_token=${sessionStorage.getItem('name')}&usid=${this.userId}`);
        let Data = res.data
        if (Data.code === 200) {
          this.count = Data.data.length;
          Data.data.forEach(item => {
            item.src = this.imgs.filter(subItem => subItem.code.indexOf(item.bank.bankCode) > -1)[0].url
            this.cardLists.push(item)
          })
        } else if (res.data.code === 400) {
          console.error(res.data.msg);
        }
        this.isShowLoading = false;
      } catch (err) {
        this.isShowLoading = false;
      }
    }
  }
};
</script>

<style lang="less" module>
.cardTitle {
  font-size: 16px;
  font-weight: bold;
  color: #191919;
  margin-top: 20px;
  span {
    margin-left: 5px;
    font-size: 12px;
    // font-weight: 400;
    em {
      margin: 0 3px;
      color: #ff0000;
    }
  }
}
dl {
  margin: 30px 10px;
  &:after {
    display: block;
    content: " ";
    overflow: hidden;
    clear: both;
  }
  .item {
    margin-right: 20px;
    float: left;
    width: 255px;
    height: 146px;
    border: 1px solid #e5e5e5;
    text-align: center;
    .icon {
      margin-top: 45px;
      font-size: 20px;
      border: 1px solid #eee;
      border-radius: 50%;
      padding: 3px;
      cursor: pointer;
    }
    .desc {
      margin-top: 5px;
      color: #169bd5;
      cursor: pointer;
    }
    .img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: 1px solid #eee;
      margin-top: 35px;
    }
    h4 {
      font-size: 20px;
      font-weight: bold;
      color: #191919;
    }
  }
}
</style>